module.exports = __webpack_public_path__ + "static/media/trendingmeanreverting.f38fc56a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/trendingmeanreverting.svg
// module id = 671
// module chunks = 0